function isElementScrollable(element) {
  if (!element) return false;
  return {
    scrollable: element.scrollHeight > element.clientHeight,
    scrollHeight: element.scrollHeight,
    clientHeight: element.clientHeight,
  };
}

function validateTableHeight(tableContainerEl, minHeight = 10) {
  if (!tableContainerEl) return false;
  return tableContainerEl.clientHeight >= minHeight;
}
export function calculateTableHeight(
  vm,
  {
    hasSearchForm = true,
    hasOperationButtonArea = true,
    hasTabs = true,
    hasTip = false,
    hasSpecialTabs = false,
    hasTopTabs = false,
    treeListRefName = "treeListRef",
    searchFormRefName = "searchFormRef",
    operationButtonAreaRefName = "operationButtonAreaRef",
    tabsRefName = "tabsRef",
    tipRefName = "tipRef",
    tableCurrentHeightField = "tableCurrentHeight",
    isFixedHeight = false,
  } = {},
  count = 0,
  retryCount = 0
) {
  const maxRetries = 5;
  const retryDelay = 80;
  vm.$nextTick(() => {
    // 获取表格树
    const treeListRef = vm.$refs[treeListRefName];
    if (!treeListRef) {
      if (retryCount < maxRetries) {
        setTimeout(
          () => calculateTableHeight(vm, arguments[1], count, retryCount + 1),
          retryDelay
        );
      }
      return;
    }
    const treeListEl = treeListRef.$el;
    // 获取表格元素
    const tableEl = treeListEl.querySelector(".el-table");
    const tableContainerEl = treeListEl.querySelector(
      ".el-table__body-wrapper"
    );
    // 判断表格是否存在容器
    if (!tableEl || !tableContainerEl) {
      if (retryCount < maxRetries) {
        setTimeout(
          () => calculateTableHeight(vm, arguments[1], count, retryCount + 1),
          retryDelay
        );
      }
      return;
    }
    // 判断表格高度是否符合要求
    if (!validateTableHeight(tableContainerEl)) {
      if (retryCount < maxRetries) {
        setTimeout(
          () => calculateTableHeight(vm, arguments[1], count, retryCount + 1),
          retryDelay
        );
      }
      return;
    }
    // 判断表格滚动
    const tableScrollable = isElementScrollable(tableContainerEl);
    // 判断页面滚动
    const html = document.documentElement;
    const htmlScrollable = isElementScrollable(html);

    // 1.页面头部高度
    let pageHeaderHeight = 50;
    let pageHeaderEl = document.getElementById("systemHeader");
    if (pageHeaderEl) {
      pageHeaderHeight = pageHeaderEl.offsetHeight;
    }
    // 2.面包屑/导航栏高度
    let breadcrumbOrNavHeight = 0;
    let breadcrumbEl = document.getElementById("breadcrumbEl");
    if (breadcrumbEl) {
      breadcrumbOrNavHeight = breadcrumbEl.offsetHeight;
    }
    // 3.提示栏高度
    let tipHeight = 0;
    if (hasTip) {
      let tipRef = vm.$refs[tipRefName];
      tipHeight = tipRef.offsetHeight;
    }
    // 4.查询表单高度
    let searchFormHeight = 0;
    if (hasSearchForm) {
      let searchForm = vm.$refs[searchFormRefName];
      searchFormHeight = searchForm.offsetHeight + 15;
    }
    // 5.操作栏高度
    let operationButtonAreaHeight = 0;
    if (hasOperationButtonArea) {
      let operationButtonArea = vm.$refs[operationButtonAreaRefName];
      operationButtonAreaHeight = hasOperationButtonArea
        ? operationButtonArea.offsetHeight
        : 0;
      // 操作栏固定
      operationButtonArea.style.position = "sticky";
      operationButtonArea.style.top =
        pageHeaderHeight + breadcrumbOrNavHeight + "px";
      operationButtonArea.style.zIndex = 17;
    }
    // 6.标签栏高度
    let tabsHeight = 0;
    if (hasTabs) {
      let tabsRef = vm.$refs[tabsRefName].$el;
      tabsHeight = hasTabs ? tabsRef.offsetHeight : 0;
      // 标签栏固定
      tabsRef.style.position = "sticky";
      tabsRef.style.top =
        pageHeaderHeight +
        breadcrumbOrNavHeight +
        operationButtonAreaHeight +
        "px";
      tabsRef.style.zIndex = 17;
    }
    // 7.分页器高度
    let paginationHeight = 0;
    let treeListFirstPagingEl = Array.from(treeListEl.children).find((child) =>
      child.classList.contains("treeListFirstPaging")
    );
    if (treeListFirstPagingEl) {
      paginationHeight = treeListFirstPagingEl.offsetHeight;
    }
    // 8.页面内下间距
    let pagePaddingBottom = 0;
    // 联想浏览器
    if (window.navigator.appCodeName == "Mozilla") {
      pagePaddingBottom = 1;
    }
    // 9.特殊状态栏
    let specialTabsHeight = 0;
    if (hasSpecialTabs) {
      let specialTabs = vm.$refs["specialTabsRef"];
      if (specialTabs) {
        specialTabsHeight = hasSpecialTabs ? specialTabs.offsetHeight : 0;
        // 特殊状态栏固定
        specialTabs.style.position = "sticky";
        specialTabs.style.top =
          pageHeaderHeight +
          breadcrumbOrNavHeight +
          operationButtonAreaHeight +
          tabsHeight +
          "px";
        specialTabs.style.zIndex = 17;
      }
    }
    // 10.顶部标签栏高度
    let topTabsHeight = 0;
    if (hasTopTabs) {
      let topTabs = vm.$refs["topTabsRef"];
      topTabsHeight = hasTopTabs ? topTabs.$el.offsetHeight : 0;
    }

    // 表格表头固定
    const tableHeaderEl = tableEl.querySelector(".el-table__header-wrapper");
    tableHeaderEl.style.position = "sticky";
    tableHeaderEl.style.top =
      pageHeaderHeight +
      breadcrumbOrNavHeight +
      operationButtonAreaHeight +
      tabsHeight +
      specialTabsHeight +
      "px";
    tableHeaderEl.style.zIndex = 17;
    if (isFixedHeight) {
      let temp =
        window.innerHeight -
        pageHeaderHeight -
        breadcrumbOrNavHeight -
        tipHeight -
        searchFormHeight -
        operationButtonAreaHeight -
        tabsHeight -
        specialTabsHeight -
        paginationHeight -
        topTabsHeight -
        pagePaddingBottom;

      vm[tableCurrentHeightField] = temp;
      tableEl.style.height = temp + "px";
      tableEl.style.maxHeight = null;
      return;
    }

    // console.log(
    //   tableScrollable.scrollable,
    //   htmlScrollable.scrollable,
    //   window.innerHeight,
    //   pageHeaderHeight,
    //   breadcrumbOrNavHeight,
    //   tipHeight,
    //   searchFormHeight,
    //   operationButtonAreaHeight,
    //   tabsHeight,
    //   specialTabsHeight,
    //   paginationHeight,
    //   topTabsHeight,
    //   pagePaddingBottom
    // );

    if (!tableScrollable.scrollable && !htmlScrollable.scrollable) {
      // 屏幕高度 - 头部高度 - 面包屑高度/导航栏高度 - 查询表单高度 - 操作栏高度 - 标签栏高度  - 分页器高度 - 页面内下间距
      let temp =
        window.innerHeight -
        pageHeaderHeight -
        breadcrumbOrNavHeight -
        tipHeight -
        searchFormHeight -
        operationButtonAreaHeight -
        tabsHeight -
        specialTabsHeight -
        paginationHeight -
        topTabsHeight -
        pagePaddingBottom;
      // vm.$set(vm, "tableCurrentHeight", temp);
      vm[tableCurrentHeightField] = temp;
      tableEl.style.height = temp + "px";
      tableEl.style.maxHeight = null;
    } else {
      vm[tableCurrentHeightField] = 0;
      tableEl.style.height = null;
    }

    // 预防窗口变化时高度没有及时更新
    if (count > 1) {
      return;
    }
    setTimeout(() => {
      const htmlScrollable2 = isElementScrollable(html);
      if (htmlScrollable2.scrollHeight != htmlScrollable.scrollHeight) {
        calculateTableHeight(
          vm,
          {
            hasSearchForm,
            hasOperationButtonArea,
            hasTabs,
            hasTip,
            hasSpecialTabs,
            hasTopTabs,
            treeListRefName,
            searchFormRefName,
            operationButtonAreaRefName,
            tabsRefName,
            tipRefName,
          },
          count + 1,
          retryCount
        );
      }
    }, 100);
  });
}

// 创建用于计算表格高度的窗口大小变化事件监听器
import debounce from "lodash/debounce";
export function addResizeListenerForCalculateTableHeight(vm, fn) {
  // 防抖
  vm.resizeHandler = debounce(() => {
    // 等待浏览器重排
    requestAnimationFrame(() => {
      if (!fn) {
        calculateTableHeight(vm, vm.calculateSetting);
      } else {
        fn();
      }
    });
  }, 100);
  window.addEventListener("resize", vm.resizeHandler, false);
}

// 移除用于计算表格高度的窗口大小变化事件监听器
export function removeResizeListenerForCalculateTableHeight(vm) {
  window.removeEventListener("resize", vm.resizeHandler, false);
}
